import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ValidationErrors, AbstractControl } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-app/shared/control-value-accessor-validator-base';
import { isNullOrUndefined } from '@fi-app/shared/utils/is-null-or-undefined';

@Component({
    selector: 'fi-quiz-threshold-settings',
    templateUrl: './quiz-threshold-settings.component.html',
    styleUrl: './quiz-threshold-settings.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-quiz-threshold-settings' },
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiQuizThresholdSettingsComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiQuizThresholdSettingsComponent,
            multi: true,
        },
    ],
})
export class FiQuizThresholdSettingsComponent extends ControlValueAccessorValidatorBase<number> {
    protected readonly ComplianceThresholdValues = [100, 95, 90, 85, 80, 75, 70];

    public doValidate(c: AbstractControl): ValidationErrors {
        return {
            'threshold-settings-required': isNullOrUndefined(this.ngModel),
        };
    }
}
